import { render, staticRenderFns } from "./CustomersConsents.vue?vue&type=template&id=02b79c0b&"
import script from "./CustomersConsents.vue?vue&type=script&lang=ts&"
export * from "./CustomersConsents.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports